import Hero from "./Hero";
import Offerings from "./offerings";
import Footer from "../../components/Footer";
import { Box } from "@mui/material";
import Locations from "./Locations";

const AroundUs = () => {
  return (
    <Box>
      <Hero />
      <Offerings />
      <Locations />
      <Footer />
    </Box>
  );
};

export default AroundUs;
